import { render, staticRenderFns } from "./ExtratoDeContas.vue?vue&type=template&id=0edd5d70&"
import script from "./ExtratoDeContas.vue?vue&type=script&lang=js&"
export * from "./ExtratoDeContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports